import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import SimplePaper from "../components/SimplePaper";

// Styling (optional or customize further)
const styles = { // eslint-disable-line no-unused-vars
  root: {
    padding: "32px",
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    borderRadius: "16px",
  },
  header: {
    marginBottom: "24px",
    color: "#2e7d32",
    textAlign: "center",
  },
};

const Theory = () => {
  const title = "Theory"; // it can be OPC,

  const body = (
    <>
      {/* <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>1. Introduction to Astrodata</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>Overview of Astrodata. Below are subtopics:</Typography>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>1.1 Basics of Astrodata</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>1.1.1 Data Collection</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>1.1.1.1 Data Sources</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Link to="/theory/intro-to-astrodata">
                        <Typography>Go to Introduction to Astrodata</Typography>
                      </Link>
                    </AccordionDetails>
                  </Accordion>
                </AccordionDetails>
              </Accordion>
            </AccordionDetails>
          </Accordion>
        </AccordionDetails>
      </Accordion> */}

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Divisional Chart Calculations from D1</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <Link
              to="/theory/divisional-charts-from-d1/d2"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px", // Adjust width as needed
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D2 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d3"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px", // Adjust width as needed
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D3 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d4"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px", // Adjust width as needed
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D4 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d5"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px", // Adjust width as needed
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D5 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d6"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px", // Adjust width as needed
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D6 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d7"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px", // Adjust width as needed
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D7 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d8"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D8 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d9"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D9 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d10"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D10 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d11"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D11 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d12"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D12 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d16"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D16 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d20"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D20 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d24"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D24 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d27"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D27 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d30"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D30 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d40"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D40 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d45"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D45 from D1
              </Typography>
            </Link>
            <Link
              to="/theory/divisional-charts-from-d1/d60"
              style={{
                textDecoration: "none",
                color: "#1976d2",
                width: "150px",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                D60 from D1
              </Typography>
            </Link>
          </div>
        </AccordionDetails>
      </Accordion>

      {/* <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>3. Advanced Techniques in Data Processing</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>Explore advanced data processing techniques.</Typography>
          <Link to="/theory/advanced-techniques">
            <Typography>
              Go to Advanced Techniques in Data Processing
            </Typography>
          </Link>
        </AccordionDetails>
      </Accordion> */}
    </>
  );

  return <SimplePaper title={title} body={body} />;
};

export default Theory;
